import { in_array, strtolower, strval, empty } from '../../php-compat';
import type { PortEnv } from '../../port-contract';
import { isArray, slot, type Arr } from './access';
import { catalogVariable, catalogRows } from './catalog';
export interface StatusDispelDeps {
    'StatusEffect::getStackInfo'(id: string): Arr | null;
    'StatusEffect::getQuantityInfo'(id: string): Arr | null;
    check_uuid(id: unknown): boolean;
}
/** PHP: StatusEffect::getUndispellableStatuses (includes/catalogs/StatusEffect.php:2002) */
export function getUndispellableStatuses(): string[] {
    return ['unconscious', 'dying', 'dead', 'stabilized', 'on_deaths_door', 'crippled', 'dying_state', 'recovery_state',
        'encumbered', 'heavily_encumbered', 'shield_encumbered', 'armor_encumbered',
        'photosensitive_eye_strain', 'extreme_photosensitive_eye_strain',
        'fate_card_suit_love', 'fate_card_suit_war', 'fate_card_suit_prosperity', 'fate_card_suit_change',
        'flanked', 'squeezed', 'very_squeezed', 'hunger_and_thirst_tick', 'thirsty', 'parched', 'desiccating', 'hungry', 'starving',
        'mounted', 'ridden', 'riding', 'piloting', 'piloted', 'reading', 'training', 'searching', 'resting', 'fully_rested',
        'sneaking', 'hidden', 'shadowform', 'awake', 'arcane_fatigue', 'summon_tag'];
}
/** PHP: StatusEffect::isUndispellable (includes/catalogs/StatusEffect.php:2049) */
export function isUndispellable(id: string, env: PortEnv<StatusDispelDeps>): boolean {
    if (id === '') return false;
    const set = getUndispellableStatuses();
    const variable = catalogVariable('StatusEffect', id, env);
    if (variable !== null && in_array(variable, set, true)) return true;
    const stack = env.deps['StatusEffect::getStackInfo'](id);
    if (stack !== null && in_array(slot(stack, 'base'), set, true)) return true;
    const quantity = env.deps['StatusEffect::getQuantityInfo'](id);
    if (quantity !== null && in_array(slot(quantity, 'base'), set, true)) return true;
    const meta = !empty(id) && env.deps.check_uuid(id) ? [...catalogRows('StatusEffect').values()].find(row => slot(row, 'item_id') === id) ?? null : null;
    const type = isArray(meta) ? strtolower(strval(slot(meta, 'status_type') ?? '')) : '';
    return type !== 'boon' && type !== 'bane';
}
